export function RubyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      id="ruby"
      {...props}
    >
      <linearGradient
        id="a"
        x1="157.08"
        x2="131.682"
        y1="2382.05"
        y2="2426.892"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#FB7655"></stop>
        <stop offset="0" stop-color="#FB7655"></stop>
        <stop offset=".41" stop-color="#E42B1E"></stop>
        <stop offset=".99" stop-color="#900"></stop>
        <stop offset="1" stop-color="#900"></stop>
      </linearGradient>
      <path
        fill="url(#a)"
        d="M97.078 83.214l-68.738 40.817 89.003-6.04 6.855-89.745z"
      ></path>
      <linearGradient
        id="b"
        x1="169.731"
        x2="136.998"
        y1="2419.72"
        y2="2441.685"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#871101"></stop>
        <stop offset="0" stop-color="#871101"></stop>
        <stop offset=".99" stop-color="#911209"></stop>
        <stop offset="1" stop-color="#911209"></stop>
      </linearGradient>
      <path
        fill="url(#b)"
        d="M117.488 117.93l-7.649-52.799-20.837 27.514z"
      ></path>
      <linearGradient
        id="c"
        x1="143.542"
        x2="110.81"
        y1="2380.69"
        y2="2402.655"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#871101"></stop>
        <stop offset="0" stop-color="#871101"></stop>
        <stop offset=".99" stop-color="#911209"></stop>
        <stop offset="1" stop-color="#911209"></stop>
      </linearGradient>
      <path
        fill="url(#c)"
        d="M117.592 117.93l-56.044-4.399-32.91 10.385z"
      ></path>
      <linearGradient
        id="d"
        x1="74.817"
        x2="79.891"
        y1="2435.622"
        y2="2402.644"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".23" stop-color="#E57252"></stop>
        <stop offset=".46" stop-color="#DE3B20"></stop>
        <stop offset=".99" stop-color="#A60003"></stop>
        <stop offset="1" stop-color="#A60003"></stop>
      </linearGradient>
      <path
        fill="url(#d)"
        d="M28.717 123.928l14.001-45.867-30.81 6.588z"
      ></path>
      <linearGradient
        id="e"
        x1="109.719"
        x2="111.589"
        y1="2466.413"
        y2="2432.757"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".23" stop-color="#E4714E"></stop>
        <stop offset=".56" stop-color="#BE1A0D"></stop>
        <stop offset=".99" stop-color="#A80D00"></stop>
        <stop offset="1" stop-color="#A80D00"></stop>
      </linearGradient>
      <path
        fill="url(#e)"
        d="M88.996 92.797l-12.882-50.46-36.866 34.558z"
      ></path>
      <linearGradient
        id="f"
        x1="140.691"
        x2="146.289"
        y1="2497.523"
        y2="2473.401"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".18" stop-color="#E46342"></stop>
        <stop offset=".4" stop-color="#C82410"></stop>
        <stop offset=".99" stop-color="#A80D00"></stop>
        <stop offset="1" stop-color="#A80D00"></stop>
      </linearGradient>
      <path
        fill="url(#f)"
        d="M121.275 43.047l-34.849-28.462-9.704 31.373z"
      ></path>
      <linearGradient
        id="g"
        x1="123.6"
        x2="147.719"
        y1="2506.018"
        y2="2518.077"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".54" stop-color="#C81F11"></stop>
        <stop offset=".99" stop-color="#BF0905"></stop>
        <stop offset="1" stop-color="#BF0905"></stop>
      </linearGradient>
      <path
        fill="url(#g)"
        d="M104.978 4.437l-20.497 11.327-12.93-11.479z"
      ></path>
      <linearGradient
        id="h"
        x1="53.674"
        x2="55.66"
        y1="2444.028"
        y2="2424.153"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".31" stop-color="#DE4024"></stop>
        <stop offset=".99" stop-color="#BF190B"></stop>
        <stop offset="1" stop-color="#BF190B"></stop>
      </linearGradient>
      <path fill="url(#h)" d="M3.802 100.034l8.586-15.659-6.946-18.655z"></path>
      <path
        fill="#fff"
        d="M4.981 65.131l6.987 19.821 30.365-6.812 34.667-32.218 9.783-31.075-15.403-10.878-26.19 9.802c-8.252 7.675-24.263 22.86-24.84 23.146-.573.291-10.575 19.195-15.369 28.214z"
      ></path>
      <linearGradient
        id="i"
        x1="40.026"
        x2="133.345"
        y1="2418.781"
        y2="2514.739"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#BD0012"></stop>
        <stop offset="0" stop-color="#BD0012"></stop>
        <stop offset=".07" stop-color="#fff"></stop>
        <stop offset=".17" stop-color="#fff"></stop>
        <stop offset=".27" stop-color="#C82F1C"></stop>
        <stop offset=".33" stop-color="#820C01"></stop>
        <stop offset=".46" stop-color="#A31601"></stop>
        <stop offset=".72" stop-color="#B31301"></stop>
        <stop offset=".99" stop-color="#E82609"></stop>
        <stop offset="1" stop-color="#E82609"></stop>
      </linearGradient>
      <path
        fill="url(#i)"
        d="M29.519 29.521c17.882-17.73 40.937-28.207 49.785-19.28 8.843 8.926-.534 30.62-18.418 48.345-17.884 17.725-40.653 28.779-49.493 19.852-8.849-8.92.242-31.191 18.126-48.917z"
      ></path>
      <linearGradient
        id="j"
        x1="111.507"
        x2="83.398"
        y1="2409.102"
        y2="2416.039"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#8C0C01"></stop>
        <stop offset="0" stop-color="#8C0C01"></stop>
        <stop offset=".54" stop-color="#990C00"></stop>
        <stop offset=".99" stop-color="#A80D0E"></stop>
        <stop offset="1" stop-color="#A80D0E"></stop>
      </linearGradient>
      <path
        fill="url(#j)"
        d="M28.717 123.909l13.89-46.012 46.135 14.82c-16.68 15.642-35.233 28.865-60.025 31.192z"
      ></path>
      <linearGradient
        id="k"
        x1="159.785"
        x2="134.814"
        y1="2442.837"
        y2="2465.217"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#7E110B"></stop>
        <stop offset="0" stop-color="#7E110B"></stop>
        <stop offset=".99" stop-color="#9E0C00"></stop>
        <stop offset="1" stop-color="#9E0C00"></stop>
      </linearGradient>
      <path
        fill="url(#k)"
        d="M77.062 45.831l11.844 46.911c13.934-14.65 26.439-30.401 32.563-49.883l-44.407 2.972z"
      ></path>
      <linearGradient
        id="l"
        x1="168.959"
        x2="156.521"
        y1="2483.901"
        y2="2497.199"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#79130D"></stop>
        <stop offset="0" stop-color="#79130D"></stop>
        <stop offset=".99" stop-color="#9E120B"></stop>
        <stop offset="1" stop-color="#9E120B"></stop>
      </linearGradient>
      <path
        fill="url(#l)"
        d="M121.348 43.097c4.74-14.305 5.833-34.825-16.517-38.635l-18.339 10.13 34.856 28.505z"
      ></path>
      <path
        fill="#9E1209"
        d="M3.802 99.828c.656 23.608 17.689 23.959 24.945 24.167l-16.759-39.14-8.186 14.973z"
      ></path>
      <radialGradient
        id="m"
        cx="138.703"
        cy="2464.789"
        r="30.601"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#A80D00"></stop>
        <stop offset="0" stop-color="#A80D00"></stop>
        <stop offset=".99" stop-color="#7E0E08"></stop>
        <stop offset="1" stop-color="#7E0E08"></stop>
      </radialGradient>
      <path
        fill="url(#m)"
        d="M77.128 45.904c10.708 6.581 32.286 19.798 32.723 20.041.68.383 9.304-14.542 11.261-22.976l-43.984 2.935z"
      ></path>
      <radialGradient
        id="n"
        cx="96.325"
        cy="2424.465"
        r="40.679"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#A30C00"></stop>
        <stop offset="0" stop-color="#A30C00"></stop>
        <stop offset=".99" stop-color="#800E08"></stop>
        <stop offset="1" stop-color="#800E08"></stop>
      </radialGradient>
      <path
        fill="url(#n)"
        d="M42.589 77.897l18.57 35.828c10.98-5.955 19.579-13.211 27.454-20.983l-46.024-14.845z"
      ></path>
      <linearGradient
        id="o"
        x1="67.509"
        x2="57.373"
        y1="2393.115"
        y2="2427.506"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#8B2114"></stop>
        <stop offset="0" stop-color="#8B2114"></stop>
        <stop offset=".43" stop-color="#9E100A"></stop>
        <stop offset=".99" stop-color="#B3100C"></stop>
        <stop offset="1" stop-color="#B3100C"></stop>
      </linearGradient>
      <path
        fill="url(#o)"
        d="M11.914 84.904l-2.631 31.331c4.964 6.781 11.794 7.371 18.96 6.842-5.184-12.9-15.538-38.696-16.329-38.173z"
      ></path>
      <linearGradient
        id="p"
        x1="145.272"
        x2="167.996"
        y1="2507.076"
        y2="2497.045"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#B31000"></stop>
        <stop offset="0" stop-color="#B31000"></stop>
        <stop offset=".44" stop-color="#910F08"></stop>
        <stop offset=".99" stop-color="#791C12"></stop>
        <stop offset="1" stop-color="#791C12"></stop>
      </linearGradient>
      <path
        fill="url(#p)"
        d="M86.384 14.67l36.891 5.177c-1.969-8.343-8.015-13.727-18.32-15.41l-18.571 10.233z"
      ></path>
    </svg>
  );
}

export default RubyIcon;
